import { useState } from 'react';
import { orderBy } from 'firebase/firestore';
import { SortDirection } from '../types';

interface SortOptions {
  forcedSortField?: string;
  sortDirection?: SortDirection | SortDirection[];
  sortFieldOverrides?: Record<string, (element: unknown) => number | string>;
}

export function useSorting(
  defaultSortField: string | string[],
  options: SortOptions = {}
) {
  const {
    forcedSortField,
    sortDirection: defaultSortDirection = 'asc',
    sortFieldOverrides,
  } = options;

  const [sortField, setSortField] = useState<string | string[]>(
    defaultSortField
  );
  const [sortDirection, setSortDirection] = useState<
    SortDirection | SortDirection[]
  >(defaultSortDirection);

  const sortByField = (property: string) => {
    if (sortField === property) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(property);
      setSortDirection('asc');
    }
  };

  const asQueryOrderByConstraints = () => {
    const sf = Array.isArray(sortField) ? sortField : [sortField];
    const sd = Array.isArray(sortDirection) ? sortDirection : [sortDirection];
    return sf.map((sf, i) => orderBy(sf, sd[i] ?? 'asc'));
  };

  return {
    defaultSortDirection,
    defaultSortField,
    sortByField,
    asQueryOrderByConstraints,
    sortDirection,
    sortField: forcedSortField ?? sortField,
    sortFieldOverrides,
  };
}
